import { flexGap } from "@doltech/utils/lib/css-style";
import styled from 'styled-components';

export const Flex = styled.div<{
  col?: boolean;
  gap?: number;
  center?: boolean;
  centerX?: boolean;
  centerY?: boolean;
  end?: boolean;
  endX?: boolean;
  endY?: boolean;
  wrap?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
  spaceBetween?: boolean;
}>`
  display: flex;
  ${({ gap = 16, col }) => flexGap(gap, col ? 'column' : 'row')}

  flex-flow: ${({ col, wrap }) => `${col ? 'column' : 'row'} ${wrap ? 'wrap' : 'nowrap'}`};

  justify-content: ${({ center, centerX, end, endX, spaceBetween }) => {
    if (spaceBetween) return 'space-between';
    if (center || centerX) return 'center';
    if (end || endX) return 'flex-end';
    return 'flex-start';
  }};

  align-items: ${({ center, centerY, end, endY }) => {
    if (center || centerY) return 'center';
    if (end || endY) return 'flex-end';
    return 'flex-start';
  }};

  width: ${({ fullWidth }) => {
    if (fullWidth) return '100%';
    return 'auto';
  }};

  height: ${({ fullHeight }) => {
    if (fullHeight) return '100%';
    return 'auto';
  }};
`;
